import React, { useEffect, useState, useRef } from "react";
import LoadingOverlay from "react-loading-overlay";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { Modal } from "react-bootstrap";
import Cookies from "js-cookie";
import * as Constants from "../../constants/Constants";
import {
  LOCK_ICON,
  MAXIMISE_ICON,
  MINIMISE_ICON,
  UNLOCK_ICON,
} from "../../assets/js/image";
import "./DocumentLibrary.css";

import ErrorContainer from "../Common/Errors/ErrorContainer";

import {
  httpGetDocumentLibraryRecentUpdateList,
  httpGetDocumentLibraryDocLinkById,
} from "../../service/httpClient";

const DocumentLibraryUpdates = (props) => {
  const {
    showMaxIcon = false,
    showMinIcon = false,
    isMaxModal = false,
    displayLoginCol = true,
    displayDescCol = false,
    isListView = false,
    listElemSize = 6,
  } = props;

  const gridRef = useRef();

  const [responseData, setResponseData] = useState([]);
  const [listViewData, setListViewData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [errorStatus, setErrorStatus] = useState(false);
  const [showFullScreen, setShowFullScreen] = useState(false);

  const loginCellRenderer = (param) => {
    return param?.value ? (
      !Cookies.get("userName") ? (
        <a className="gridCellLink" href="/login">
          <LOCK_ICON style="loginIcon" />
        </a>
      ) : (
        <UNLOCK_ICON style="loginIcon" />
      )
    ) : (
      ""
    );
  };

  const handleGetDocumentLinkById = (id, documentName) => {
    try {
      httpGetDocumentLibraryDocLinkById(id)
        .then((response) => {
          const { data = [], status, headers } = response || {};

          if (data && status === 200) {
            let contentType =
              typeof headers["content-type"] !== "undefined"
                ? headers["content-type"]
                : "application/octet-stream";

            let fileType =
              typeof Constants.FILE_MIME_TYPE[contentType] !== "undefined"
                ? Constants.FILE_MIME_TYPE[contentType]
                : "";
            let tmpFileName = `document-${documentName
              .toLowerCase()
              .replace(/ /g, "-")}`;

            let fileDt = new Blob([response.data], {
              type: contentType,
              encoding: "UTF-8",
            });
            const url = window.URL.createObjectURL(fileDt);
            const link = document.createElement("a");
            link.href = url;
            if (fileType) {
              link.setAttribute("download", `${tmpFileName}.${fileType}`);
            } else {
              link.setAttribute("target", "_blank");
            }
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            link.remove();
          } else {
            setErrorMsg(Constants.ERROR_UNABLE_TO_DOWNLOAD_FILE);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const documentCellRenderer = (params) => {
    const { data = {} } = params || {};
    const { loginRequired: login = "", id = "", documentName = "" } =
      data || {};
    return (
      <div title={params?.value}>
        {((login && Cookies.get("userName")) || !login) && id ? (
          <span
            className="gridCellLink"
            onClick={() => handleGetDocumentLinkById(id, documentName)}
          >
            {params?.value}
          </span>
        ) : (
          params?.value
        )}
      </div>
    );
  };

  const [columnDefs, setColumnDefs] = useState(
    !isListView
      ? [
          {
            headerName: Constants.LBL_LOGIN,
            field: "loginRequired",
            width: isMaxModal ? 72 : 68,
            cellRenderer: loginCellRenderer,
            filter: false,
            sortable: false,
            hide: !displayLoginCol,
          },
          {
            headerName: Constants.LBL_DOCUMENT,
            field: "documentName",
            width: isMaxModal ? 680 : 480,
            cellRenderer: documentCellRenderer,
          },
          {
            headerName: Constants.LBL_PUBLISHED,
            field: "documentPublished",
            width: isMaxModal ? 320 : 180,
            cellRenderer: (params) => {
              const { data = {} } = params || {};
              const { documentPublished = "" } = data || {};
              if (documentPublished) {
                let d = new Date(documentPublished);
                const date = d.toISOString().split("T")[0];
                const time = d.toTimeString().split(" ")[0];
                return `${date} ${time}`;
              } else {
                return "";
              }
            },
          },
          ...(displayDescCol
            ? [
                {
                  headerName: Constants.LBL_DESCRIPTION,
                  field: "documentDescription",
                  width: 500,
                  sortable: true,
                  filter: true,
                },
              ]
            : []),
        ]
      : []
  );
  const [defaultColDef, setDefaultColDef] = useState(
    !isListView
      ? {
          lockVisible: true,
          suppressMovable: true,
          enablePivot: true,
          filter: true,
          sortable: true,
          resizable: true,
        }
      : []
  );

  useEffect(() => {
    if (responseData?.length === 0) {
      getData();
    }
  }, []);

  const getData = () => {
    try {
      httpGetDocumentLibraryRecentUpdateList()
        .then((response) => {
          const { data = [], status } = response || {};
          if (data && data?.length > 0 && status === 200) {
            setResponseData(data);
            if (isListView) {
              setListViewData(data.slice(0, listElemSize));
            }
          } else {
            setResponseData([]);
            if (isListView) {
              setListViewData([]);
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const handleDocLibMinMax = (popupState) => {
    setShowFullScreen(popupState);
  };

  const ModalFullScreenDocLib = (props) => {
    const { showMinIcon = false } = props;
    return (
      <div className="fullscreenModalContainer">
        <Modal
          show={showFullScreen}
          size="xl"
          onHide={() => handleDocLibMinMax(false)}
          backdrop="static"
          animation={true}
        >
          <Modal.Header closeButton={false}>
            <Modal.Title>{""}</Modal.Title>
            {showMinIcon ? (
              <span
                className="maxMinIcon"
                onClick={() => handleDocLibMinMax(false)}
              >
                <MINIMISE_ICON style="minimiseIcon" />
              </span>
            ) : (
              ""
            )}
          </Modal.Header>
          <Modal.Body>
            <div className="fullscreen-docLibContainer">
              <DocumentLibraryUpdates
                showMaxIcon={false}
                showMinIcon={false}
                handleDocLibMinMax={handleDocLibMinMax}
                isMaxModal={true}
              />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  };

  return (
    <div
      className={
        isListView ? "list-view-main-container" : "gridMinMaxMainContainer"
      }
    >
      <div className="m-top-10">
        <ErrorContainer
          errorMsg={errorMsg}
          updateStatus={updateStatus}
          successMsg={successMsg}
          errorStatus={errorStatus}
          errorStyle="errorMessage"
          successStyle="successMessage"
        />
      </div>
      <LoadingOverlay active={isLoading} spinner>
        <ModalFullScreenDocLib showMinIcon={true} />
        {!isListView ? (
          <>
            <div className="gridHeading">
              {Constants.DOCUMENT_LIBRARY_RECENT_UPDATES + " "}(
              {responseData && responseData?.length})
              {showMaxIcon ? (
                <span
                  className="maxMinIcon"
                  onClick={() => handleDocLibMinMax(true)}
                >
                  <MAXIMISE_ICON style="maximiseIcon" />
                </span>
              ) : (
                ""
              )}
              {showMinIcon ? (
                <span
                  className="maxMinIcon"
                  onClick={() => handleDocLibMinMax(false)}
                >
                  <MINIMISE_ICON style="minimiseIcon" />
                </span>
              ) : (
                ""
              )}
            </div>

            <div className="ag-theme-balham gridMinMaxSubContainer">
              <AgGridReact
                ref={gridRef}
                columnDefs={columnDefs}
                rowData={responseData}
                defaultColDef={defaultColDef}
                overlayNoRowsTemplate={
                  responseData.length > 0 ? "" : Constants.NO_DATA_FOUND
                }
              />
            </div>
          </>
        ) : (
          <div className="list-container">
            {listViewData.length > 0 ? (
              <>
                <div className="cls-view-more">
                  <span
                    className="cls-link"
                    onClick={() => handleDocLibMinMax(true)}
                  >
                    {Constants.VIEW_MORE}
                  </span>
                </div>
                <div className="list-item-main">
                  <>
                    {listViewData?.map((list, i) => {
                      return (
                        <div key={i}>
                          <span className="dl-lock-icon">
                            {loginCellRenderer({ value: list?.loginRequired })}
                          </span>
                          <span className="dl-list-link">
                            {((list?.loginRequired &&
                              Cookies.get("userName")) ||
                              !list?.loginRequired) &&
                            list?.id ? (
                              <span
                                className="dl-dlink"
                                onClick={() =>
                                  handleGetDocumentLinkById(
                                    list?.id,
                                    list?.documentName
                                  )
                                }
                              >
                                {list?.documentName}
                              </span>
                            ) : (
                              list?.documentName
                            )}
                          </span>
                          <br />
                          <span className="dl-list-highlight">
                            {list?.documentPublished
                              ? new Date(
                                  list?.documentPublished
                                ).toLocaleDateString()
                              : ""}
                          </span>
                        </div>
                      );
                    })}
                  </>
                </div>
              </>
            ) : (
              <div className="cls-list-nodata">
                {isLoading
                  ? Constants.LOADING
                  : Constants.DOC_LIB_MSG_NO_RECENT_UPDATES}
              </div>
            )}
          </div>
        )}
      </LoadingOverlay>
    </div>
  );
};

export default DocumentLibraryUpdates;
